import { CardSimpleProps } from '@comfama/comfama-ui-react';
import { richTextToPlainText } from '../../../../utils/richTextToPlainText';

interface IEscuelaEmpresarialCardsProps{
    id?: string;
    heading: string;
    description: string;
    cards: (CardSimpleProps & { id: string })[];
    className?: string;
}

function escuelaEmpresarialCardsAdapter(data: any): IEscuelaEmpresarialCardsProps {
    return {
        id: data.etiquetasArticulo?.[0] ?? '',
        heading: data.tituloGeneral ?? '',
        description: richTextToPlainText(JSON.parse(data.descripcion.raw) ?? ''),
        cards: data.referenciaPlantillaContenido?.map((card: any, idx: number) => ({
            id: card.tituloBanner.replace(' ', '-').toLowerCase() + idx,
            title: card.tituloBanner ?? '',
            description: card.tituloDescripcion ?? '',
            icon: card?.imagenPrincipal?.[0]?.file?.url ?? '',
        })),
    };
}
export default escuelaEmpresarialCardsAdapter;
